import createCardListingView from '../Views/createCardListingView';
import FlexEventCard from './FlexEventCard';

export default createCardListingView(FlexEventCard, {
  displayName: 'EventListingView',
});
